import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import Header from "../../components/Header/";
import Sidebar from "../../components/Sidebar/";
import Breadcrumb from "../../components/Breadcrumb/";
import Aside from "../../components/Aside/";
import Footer from "../../components/Footer/";
import Dashboard from "../../views/Dashboard/";

// UI Kits
import Login from "../../views/Pages/Login";
import SalesUpload from "../../components/CustomComponents/SalesUpload";
import SalesSummery from "../../components/CustomComponents/SalesSummery";
import PaymentHistory from "../../components/CustomComponents/PaymentHistory";
import BankAccList from "../../components/CustomComponents/BankAccList";
import ReceivePayment from "../../components/CustomComponents/ReceivePayment";
import SalesRegister from "../../components/CustomComponents/SalesRegister";
import Category from "../../components/CustomComponents/Category";
import RecurringExp from "../../components/CustomComponents/RecurringExp";
import AddIncome from "../../components/CustomComponents/AddIncome";
import PaymentDue from "../../components/CustomComponents/PaymentDue";
import PurchaseRegister from "../../components/CustomComponents/PurchaseRegister";
import GstDetails from "../../components/CustomComponents/GstDetails";
import DayBook from "../../components/CustomComponents/DayBook";
import Expense from "../../components/CustomComponents/Expense";
import SaleInsert from "../../components/CustomComponents/SaleInsert";
import StockDetails from "../../components/CustomComponents/StockDetails";
import PartyDetails from "../../components/CustomComponents/PartyDetails";
import PartyDue from "../../components/CustomComponents/PartyDue";
import PaymentDueBeat from "../../components/CustomComponents/PaymentDueBeat";
import InvoiceUpload from "../../components/CustomComponents/InvoiceUpload";
import AssetsLiabilities from "../../components/CustomComponents/AssetsLiabilities";
import MsPartyUpload from "../../components/CustomComponents/MsPartyUpload";
import DocumentCenter from "../../components/CustomComponents/DocumntCenter";
import Investors from "../../components/CustomComponents/Investors";
import RecurringSetup from "../../components/CustomComponents/RecurringSetup";
import ChequeDashboard from "../../components/ChequeDashboard";
import SecondarySalesReg from "../../components/CustomComponents/SecondarySalesReg";
import VehiclesNrUploads from "../../components/CustomComponents/VehiclesNrUploads";
import DuesVerificationByOrders from "../../components/CustomComponents/DuesVerificationByOrders";
import CashDetailsCenter from "../../components/CustomComponents/CashDetailsCenter";
import EmailSyncCenter from "../../components/CustomComponents/EmailSyncCenter";
import LoadingSheet from "../../components/CustomComponents/LoadingSheet";

class Full extends Component {
  render() {
    return (
      <div className="app" style={{ background: "#f4f6fc" }}>
        <Header />
        <div className="app-body">
          <Sidebar {...this.props} />
          <main className="main" style={{ background: "#f4f6fc" }}>
            <Breadcrumb />
            <Container fluid style={{ padding: "0 20px 20px" }}>
              <Switch>
                <Route
                  path="/dashboard"
                  name="Dashboard"
                  component={Dashboard}
                />
                <Route path="/login" name="login" component={Login} />

                <Route
                  path="/sales/register"
                  name="Sales Register"
                  component={SalesRegister}
                />
                <Route
                  path="/sales/invoieUpload"
                  name="Invoice Upload"
                  component={InvoiceUpload}
                />
                <Route
                  path="/sales/upload"
                  name="Sales Upload"
                  component={SalesUpload}
                />
                <Route
                  path="/vehicles/upload"
                  name="Vehicles Number Upload"
                  component={VehiclesNrUploads}
                />
                <Route
                  path="/dues/verification"
                  name="Dues Verification By Orders"
                  component={DuesVerificationByOrders}
                />
                <Route
                  path="/cash/details"
                  name="Cash Details Center"
                  component={CashDetailsCenter}
                />
                <Route
                  path="/sales/summery"
                  name="Sales Upload"
                  component={SalesSummery}
                />
                <Route
                  path="/purchase/upload"
                  name="Purchase Upload"
                  component={PurchaseRegister}
                />
                <Route
                  path="/sales/secondarySaleRegister"
                  name="Secondary Sale Register"
                  component={SecondarySalesReg}
                />

                <Route
                  path="/sales/pmthis"
                  name="Payment History"
                  component={PaymentHistory}
                />
                <Route
                  path="/sales/acclist"
                  name="Bank Accounts"
                  component={BankAccList}
                />
                <Route
                  path="/paymt/receive"
                  name="Receive Payment"
                  component={ReceivePayment}
                />
                <Route
                  path="/settings/cate"
                  name="Receive Payment"
                  component={Category}
                />
                <Route
                  path="/settings/recur"
                  name="Recurring Entry"
                  component={RecurringExp}
                />
                <Route
                  path="/settings/income"
                  name="Incomes"
                  component={AddIncome}
                />
                <Route
                  path="/settings/expense"
                  name="Expenses"
                  component={Expense}
                />
                <Route
                  path="/paymt/due"
                  name="Payment Due"
                  component={PaymentDue}
                />
                <Route
                  path="/paymt/beatDue"
                  name="Beat Payment Due"
                  component={PaymentDueBeat}
                />
                <Route
                  path="/reports/gst_details"
                  name="GST Details"
                  component={GstDetails}
                />
                <Route
                  path="/reports/dayBook"
                  name="Day Book"
                  component={DayBook}
                />
                <Route
                  path="/reports/loadingSheet"
                  name="Loading Sheet"
                  component={LoadingSheet}
                />
                <Route
                  path="/reports/chequedetails"
                  name="Cheque Details"
                  component={ChequeDashboard}
                />
                <Route
                  path="/masters/saleInsert"
                  name="Sale Insert"
                  component={SaleInsert}
                />
                <Route
                  path="/masters/stockDetails"
                  name="Stock Details"
                  component={StockDetails}
                />
                <Route
                  path="/masters/partyDetails"
                  name="Party Details"
                  component={PartyDetails}
                />
                <Route
                  path="/masters/assetsLiabilities"
                  name="Assets and Liabilities"
                  component={AssetsLiabilities}
                />
                <Route
                  path="/masters/partyDue"
                  name="Party Due"
                  component={PartyDue}
                />
                <Route
                  path="/masters/assetsLiabilities"
                  name="Assets and Liabilities"
                  component={AssetsLiabilities}
                />
                <Route
                  path="/masters/partyUpload"
                  name="Party Upload"
                  component={MsPartyUpload}
                />
                <Route
                  path="/masters/rateUpload"
                  name="Rate Upload"
                  component={PurchaseRegister}
                />
                <Route
                  path="/masters/documents"
                  name="Documents"
                  component={DocumentCenter}
                />
                <Route
                  path="/masters/investors"
                  name="Investors"
                  component={Investors}
                />
                <Route
                  path="/masters/recurringSetup"
                  name="Recurring Setup"
                  component={RecurringSetup}
                />
                <Route
                  path="/masters/emailSyncCenter"
                  name="Email Sync Center"
                  component={EmailSyncCenter}
                />

                <Redirect from="/" to="/dashboard" />
              </Switch>
            </Container>
          </main>
          <Aside />
        </div>
        <Footer />
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js